<div class="toggle-control cursor-pointer" (click)="disabled ? null : onClick()">
  <span class="toggle"><i class="switch" [ngClass]="{ off: !value, disabled: disabled }"></i></span>
  <span class="label" *ngIf="label">{{ label }}</span>
  <ng-content></ng-content>
</div>
